import { MouseEvent, useCallback } from "react";

import { styles } from "@repo/helpers";

import { Button } from "../button";
import style from "./styles.module.scss";
import { MarkupProps } from "./types";

export default function DropdownMarkup(props: MarkupProps) {
	const onHover = useCallback(
		function (e: MouseEvent<HTMLDivElement>) {
			if (props.openOnHover) props.dropdownClicked(e);
		},
		[props.openOnHover, props.dropdownClicked],
	);

	return (
		<div className={style.dropdown} onMouseEnter={onHover} onMouseLeave={onHover}>
			<Button onClick={props.toggleDropdown}>{props.buttonText}</Button>
			<div
				className={styles(style.dropdownContent, props.visible && style.show)}
				onClick={props.dropdownClicked}
				ref={props.dropdownRef}
			>
				{props.children}
			</div>
		</div>
	);
}
